import React from 'react';
import { FaCalendar } from "react-icons/fa"; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'édition
const ButtonCalendar = ({ onClick, className = '', hoverLabel = 'Lien Calendrier'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-green-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-blue-700 flex items-center justify-center ${className}`}
    >
      <FaCalendar  className='text-[18px]'/>
    </button>
  );
};


export default ButtonCalendar;